import React, { useState } from "react";
import { Accordian, AccordianNew, Divider } from "../../../../components";
import AccordianL1 from "./AccordianLoopData/AccordianL1";

// const AccordionData = ({ data }) => {
//   const dataw = [
//     {
//       title: "Accordion 1",
//       content: "inner page",
//     },
//     {
//       title: "Accordion 2",
//       content: "inner page",
//     },
//     {
//       title: "Accordion 3",
//       content: "inner page",
//     },
//     {
//       title: "Accordion 4",
//       content: "inner page",
//     },
//   ];
//   return (
//     <div>
//       <AccordianNew
//         data={dataw}
//         fullWidth={false}
//         color={"black"}
//         iconPosition="right"
//         openDefault={null}
//       />
//     </div>
//   );
// };

const data = [
  {
    title: "Internal Approvals",
    content: <AccordianL1 />,
  },
];
const data2 = [
  {
    title: "Open All - 1",
    content: "asdf",
  },
  {
    title: "Open All - 2",
    content: "asdf",
  },
  {
    title: "Open All - 3",
    content: "asdf",
  },
  {
    title: "Open All - 4",
    content: "asdf",
  },
];
const data3 = [
  {
    title: "Open All - 4",
    content: "asdf",
  },
  {
    title: "Open All - 5",
    content: "asdf",
  },
];

const Accordion = () => {
  const [openclick, setOpenClick] = useState(false);
  return (
    <div className="p-2 overflow-auto">
      {/* <div className={openclick ? "" : "inline-flex "}>
        <Accordian
          title="Accordion"
          iconType="contained"
          handleChangeOption={() => setOpenClick(!openclick)}
        >
          <div>accordion Content</div>
        </Accordian>
      </div>

      <Divider />
      <Accordian title="Accordion 2">
        <div>Content</div>
      </Accordian> */}

      <AccordianNew
        data={data}
        openDefault={null}
        iconPosition="right"
        variant="outlined"
        color={"white"}
      />
      <div className="mt-10 flex gap-10">
        <div className="flex-1">
          <AccordianNew
            data={data2}
            openDefault={-1}
            iconPosition="right"
            //variant="outlined"
            color={"black"}
          />
        </div>
        <div className="flex-1">
          <AccordianNew
            data={data3}
            openDefault={-1}
            iconPosition="right"
            //variant="outlined"
            color={"black"}
          />
        </div>
      </div>
    </div>
  );
};

export default Accordion;
